import React, { useState } from "react";
import { Box, Button, Container, Grid, TextField, Typography } from "@mui/material";
import { useMediaQueries } from '../../usecontext/UseProvider';
import tringle1 from '../../assets/home/tringle.png';
import tringle2 from '../../assets/home/tringle2.png';
import sendMessageIllustarter from '../../assets/home/sendMessageIllustarter.png';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const SendMessage = () => {
    const { isSmallScreen, isMediumScreen, isLargeScreen, contactUSData } = useMediaQueries();
    const { wpNumber } = useMediaQueries(); // Replace with the actual WhatsApp number or provide it here.
    const [message, setMessage] = useState(""); // State to store the message
    const address = contactUSData?.address || "New York, USA"; // Use dynamic address
    const encodedAddress = encodeURIComponent(address); // Encode for URL

    const mapUrl = `https://www.google.com/maps?q=${encodedAddress}&output=embed`;

    const handleWhatsAppClick = () => {
        const whatsappURL = `https://wa.me/${wpNumber}`;
        window.open(whatsappURL, "_blank");
    };

    const handleSendMessage = () => {
        if (!message) {
            alert("Please type a message before sending.");
            return;
        }

        const whatsappURL = `https://wa.me/${wpNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, "_blank");
        setMessage('');
    };

    const commonTextFieldStyles = {
        InputLabelProps: {
            sx: {
                color: "#A4A8B0",
                '&.Mui-focused': {
                    color: "#A4A8B0",
                },
            },
        },
        sx: {
            pl: 2,
            backgroundColor: '#fff',
            borderRadius: '50px',
            '& .MuiInputBase-root': {
                borderRadius: '50px'
            },
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    border: 'none'
                },
                '&:hover fieldset': {
                    border: 'none'
                },
                '&.Mui-focused fieldset': {
                    border: 'none'
                },
            },
        },
    };

    return (
        <Box
            sx={{
                backgroundColor: "#B9E4F5",
                // py: { md: "5rem", xs: "2rem" },
                position: { md: 'relative' },
                height: { md: '700px' },
                mb: { md: '200px' }
            }}
        >
            <Box
                component="img"
                src={tringle1}
                alt="Placeholder Image"
                sx={{
                    position: 'absolute',
                    left: 0,
                    top: '80px',
                    display: { lg: 'inline', xs: 'none' }
                }}
            />
            <Box
                component="img"
                src={tringle2}
                alt="Placeholder Image"
                sx={{
                    position: 'absolute',
                    right: 0,
                    top: '30px',
                    display: { lg: 'inline', xs: 'none' }
                }}
            />

            <Container sx={{ display: { md: 'flex' }, gap: 4, position: 'relative' }}>
                <Grid
                    container
                    spacing={isSmallScreen ? 0 : 3}
                    alignItems="center"
                    sx={{ height: '100%' }}
                    justifyContent="center"
                >
                    <Grid item sm={5} xs={12} data-aos="fade-up" sx={{ position: 'relative' }}   >
                        <Box
                            component="img"
                            src={sendMessageIllustarter}
                            alt="Placeholder Image"
                            sx={{ display: { sm: 'inline', xs: 'none' }, width: { lg: 'fit-content', xs: '100%' } }}
                        />
                    </Grid>
                    <Grid item sm={7} xs={12}>
                        <Box>
                            <Typography
                                data-aos="fade-down"
                                variant={isSmallScreen ? 'h5' : 'h4'}
                                sx={{ fontWeight: 700 }}
                                gutterBottom
                            >
                                Send us message
                            </Typography>
                            <Typography data-aos="fade-up" variant="body1" sx={{ mb: { lg: 6, xs: 3 }, fontSize: isSmallScreen ? "18px" : '22px' }}>
                                Have a question or need assistance? Send a message, and our team will respond promptly to help with your inquiry.
                            </Typography>
                            <Box data-aos="fade-up" sx={{ display: 'flex', gap: 2, alignItems: 'center', position: 'relative' }}>
                                <WhatsAppIcon
                                    sx={{ backgroundColor: '#35CC35', color: '#fff', height: '50px', width: '50px', borderRadius: '50%', p: 0.5 }}
                                    onClick={handleWhatsAppClick}
                                />
                                <TextField
                                    name="Message"
                                    placeholder="Enter your message"
                                    size={isSmallScreen ? "small" : "medium"}
                                    variant="outlined"
                                    fullWidth
                                    {...commonTextFieldStyles}
                                    onChange={(e) => setMessage(e.target.value)}
                                />
                                <Button
                                    className="hover-button"
                                    variant="contained"
                                    sx={{
                                        borderColor: '#fff',
                                        backgroundColor: '#01A0E2',
                                        color: '#fff',
                                        borderRadius: '50px',
                                        px: { sm: 4, xs: 2 },
                                        position: 'absolute', py: "2px",
                                        right: '10px', fontSize: { md: '20px' }
                                    }}
                                    onClick={handleSendMessage}
                                >
                                    Send
                                </Button>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                <Box sx={{ position: { md: 'absolute' }, bottom: { lg: '-445px', xs: '-440px' }, width: '100%', right: 0, px: { md: 4, xs: 2 }, py: { md: 0, xs: 2 } }}>
                    <iframe
                        className="map-contact"
                        src={mapUrl}
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Google Map Location"
                        style={{
                            width: '100%',
                            height: isMediumScreen ? '300px' : '400px',
                            borderRadius: '20px',
                            border: '1px solid #838383'
                        }}
                    ></iframe>
                </Box>
            </Container>
        </Box>
    );
};

export default SendMessage;
